export default "__VITE_ASSET__C9plFzdL__"